(function () {
  class BackgroundAnimsView extends PIXI.Container {
    constructor() {
      super();
    }

    initialise() {
      const self = this;
      self.addMessageListeners();
    }

    onSoundFinished() {
      self._modifierEvent.leave();
    }

    addMessageListeners() {
      var self = this;

      // messageBus.subscribe("spinner:SpinEvent", function(){
      //     self.playTitleAnim();
      // });
    }

    update() {}

    config() {}

    playTitleAnim() {
      //this.titleAnim.gotoAndPlay(0);
    }
  }

  create = function (json) {
    return new BackgroundAnimsView();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType("backgroundAnims", create, initialise, getFilesRequired);
})();
